import request from '@/CommonDP/utils/request';
// 用户中心
export default {
  // 基本资料
  getUserInfo() {
    return request.get(`/user/getUserInfo`);
  },
  // 修改基本资料
  updateUserInfo(params) {
    return request.post(`/user/updateUserInfo`, params);
  },
  // 修改密码
  changePassword(params) {
    return request.post(`/user/changePassword`, params);
  },
  // 修改密码
  uploadAvatar(params) {
    return request.post(`/pic/uploadAvatar`, params);
  },
  // 用户企业列表
  queryEnterpriseInfoList(keyword) {
    return request.get(`/user/queryEnterpriseInfoList?keyword=` + keyword);
  },
  // 查看企业资质
  getEnterpriseDetails(enterpriseId) {
    return request.get(
      '/enterprise/getEnterpriseDetails?enterpriseId=' + enterpriseId
    );
  },
  // 解散企业
  updateEnterpriseDissolve(enterpriseId) {
    return request.get(
      `/enterprise/updateEnterpriseDissolve?enterpriseId=${enterpriseId}`
    );
  },
  // 修改手机号
  updateUserPhone(params) {
    return request.post(`/user/updateUserPhone`, params);
  },
  // 退出qiye
  userexitEnterprise(enterpriseId) {
    return request.get(
      `/user/exitEnterprise?enterpriseId=${enterpriseId}`
    );
  }
};
